export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Строка от"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["до"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["символов"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Недопустимое значение"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обязательное поле"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Проверьте поля"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["латинские буквы"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["кириллица"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["цифры"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["спецсимволы"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Разрешённые символы:"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Макс."])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG, PNG или JPG"])}
}